import React, { useState, useEffect } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from './firebase';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import DishCard from './components/DishCard';
import ContactUs from './components/ContactUs';
import DeliveryPartners from './components/DeliveryPartners';
import LoginModal from './components/LoginModal';
import DishEditModal from './components/DishEditModal';
import { fetchDishes } from './dishesData';

function App() {
  const [dishes, setDishes] = useState([]);
  const [activeTab, setActiveTab] = useState('Appetizer');
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingDish, setEditingDish] = useState(null);

  // Check if user is authenticated
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setAuthLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const loadDishes = async () => {
    try {
      const fetchedDishes = await fetchDishes();
      setDishes(fetchedDishes);
    } catch (error) {
      console.error('Error loading dishes:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDishes();
  }, []);

  const tabs = [
    { id: 'Appetizer', name: 'Appetizer' },
    { id: 'entree', name: 'Entree' },
    { id: 'Rice And Bread', name: 'Rice And Bread' },
    { id: 'Side', name: 'Side' },
    { id: 'Salad', name: 'Salad' },
    { id: 'dessert', name: 'Dessert' },
    { id: 'Beverages', name: 'Beverages' }
  ];

  const filteredDishes = dishes.filter(dish => dish.category === activeTab);

  const handleEdit = (dish) => {
    setEditingDish(dish);
    setShowEditModal(true);
  };

  const handleAdd = () => {
    setEditingDish(null);
    setShowEditModal(true);
  };


  const handleSave = () => {
    loadDishes();
  };

  if (authLoading) {
    return (
      <div className="App" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <Hero />

      <div className="container" id="menu">
        <div className="tabs-container">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.name}
            </button>
          ))}
        </div>

        {user && (
          <div className="add-dish-container">
            <button 
              onClick={handleAdd}
              className="add-dish-button-main"
            >
              + Add New Dish
            </button>
          </div>
        )}

        <div className="dishes-grid">
          {filteredDishes.map(dish => (
            <DishCard 
              key={dish.id}
              dish={dish}
              isAdmin={!!user}
              onEdit={handleEdit}
            />
          ))}
        </div>

        {loading && (
          <div className="empty-state">
            <p>Loading dishes...</p>
          </div>
        )}

        {!loading && filteredDishes.length === 0 && (
          <div className="empty-state">
            <p>No dishes available in this category yet.</p>
          </div>
        )}
      </div>

      <ContactUs />

      <DeliveryPartners />

      <footer className="footer">
        <p>© 2025 Gaurav Kharel. Making your events memorable.</p>
        <p className="footer-disclaimer">*Some items may contain dairy/nuts.</p>
        {user ? (
          <p style={{ marginTop: '0.5rem', fontSize: '0.9rem', color: '#666' }}>
            Admin: {user.email} | <button 
              onClick={() => signOut(auth)} 
              style={{ 
                background: 'none', 
                border: 'none', 
                color: '#667eea', 
                cursor: 'pointer', 
                textDecoration: 'underline' 
              }}
            >
              Logout
            </button>
          </p>
        ) : (
          <p style={{ marginTop: '0.5rem' }}>
            <button 
              onClick={() => setShowLoginModal(true)}
              style={{ 
                background: 'none', 
                border: 'none', 
                color: '#667eea', 
                cursor: 'pointer', 
                textDecoration: 'underline',
                fontSize: '0.9rem'
              }}
            >
              Admin Login
            </button>
          </p>
        )}
      </footer>

      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        onLoginSuccess={() => setUser(auth.currentUser)}
        user={user}
      />

      <DishEditModal
        isOpen={showEditModal}
        onClose={() => {
          setShowEditModal(false);
          setEditingDish(null);
        }}
        dish={editingDish}
        category={activeTab}
        onSave={handleSave}
        onDelete={handleSave}
      />
    </div>
  );
}

export default App;

